export default __webpack_public_path__ + "static/media/orders-icon.076447c9.svg";